import axios from 'axios'

//const apiScope = 'api://5664675b-96f9-4260-a8a2-18b54ece7c53/Access.Events'
const apiScope = '91073084-ee2e-446e-a85d-95d69db36770/Member.Read'

// api/http.ts
import { AuthenticationContext } from "@/auth/msal-context"

export function createApiClientDefault(baseurl) {
  return createApiClient(apiScope, baseurl)
}

function isInteractionRequired(err) {
  // MSAL wirft z.B. InteractionRequiredAuthError oder errorCode wie "interaction_required", "login_required", "consent_required"
  const code = err?.errorCode || err?.code;
  return ["interaction_required", "login_required", "consent_required"].includes(code);
}

export function createApiClient(apiScope, baseurl) {
  const api = axios.create({
    baseURL: baseurl,
    timeout: 30_000,
  });

  // Scopes für deine API (typisch: api://<client-id>/<scope> oder <app-id-uri>/<scope>)
  const apiScopes = (apiScope)
    .split(",")
    .map(s => s.trim())
    .filter(Boolean);

  api.interceptors.request.use(async (config) => {
    // Optional: nur für bestimmte Hosts/Calls token anhängen
    // if (!config.url?.startsWith("/")) return config;

    const token = await AuthenticationContext.getAccessToken(apiScopes);
    if (!token) {
      return config;
    }

    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  }



  );

  // Response: 401 -> einmal forceRefresh + retry
  api.interceptors.response.use(
    (resp) => resp,
    async (error) => {
      const cfg = error.config;
      const status = error.response?.status;

      // Wenn kein Config (sehr selten) oder schon retried: raus
      if (!cfg || cfg._retry) throw error;

      if (status === 401) {
        cfg._retry = true;

        try {
          // forceRefresh erzwingt neuen Token (soweit möglich)
          const newToken = await AuthenticationContext.getAccessToken(apiScopes, { forceRefresh: true });
          cfg.headers = cfg.headers ?? {};
          cfg.headers.Authorization = `Bearer ${newToken}`;

          return api.request(cfg);
        } catch (msalErr) {
          if (isInteractionRequired(msalErr)) {
            //opts.onInteractionRequired?.(msalErr);
          }
          throw msalErr;
        }
      }
      throw error;
    });



  return api;
}